require('./bootstrap');

// window.Vue = require('vue');

// /**
//  * Next, we will create a fresh Vue application instance and attach it to
//  * the page. Then, you may begin adding components to this application
//  * or customize the JavaScript scaffolding to fit your unique needs.
//  */

// Vue.component('example-component', require('./components/ExampleComponent.vue'));

// window.addEventListener('load', function () {
//     const app = new Vue({
//         el: '#app'
//     });
// })

window.enableInput = function(elementId, enabled) {
    if (enabled) {
        document.getElementById(elementId).style.display = '';
        var inputs = document.getElementById(elementId).querySelectorAll('input,select');
        for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].type !== 'submit') {
                inputs[i].removeAttribute("disabled");
            }
        }
    } else {
        document.getElementById(elementId).style.display = 'none';
        var inputs = document.getElementById(elementId).querySelectorAll('input,select');
        for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].type !== 'submit') {
                inputs[i].setAttribute("disabled","true");
            }
        }
    }
}

window.popup = function(url, width, height, window_name) {
    if (!width) {
        width = 1024;
    }
    if (!height) {
        height = 768;
    }
    if (!window_name) {
        window_name = 'exelbid_popup';
    }

    var left = (screen.width - (width + 150)) / 2;
    var top = (screen.height - (height + 150)) / 2;

    var popup = window.open(url, window_name, 'width=' + width + ', height=' + height + ', top=' + top + ', left=' + left + ', resizable=yes, scrollbars=yes, location=no, menubar=no');
    windowObj.focus();
}
